export const environment = {
  production: true,
  USER_API_KEY: 'ieQL41NAJSykhhbNZIp',
  _api_base_url: 'https://api.markit.place',
  recaptcha_site_key: '6LcG-JMbAAAAAGNmatW14Btc_Ko38a8rEAi2qvxl'
};
